import { render, staticRenderFns } from "./QuestionsBox.vue?vue&type=template&id=1f30f208&scoped=true&"
import script from "./QuestionsBox.vue?vue&type=script&lang=js&"
export * from "./QuestionsBox.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsBox.vue?vue&type=style&index=0&id=1f30f208&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f30f208",
  null
  
)

export default component.exports